import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

export function useMyConnectorGrants({ enabled = true } = {}) {
  const [user, userResult] = useQuery(queries.currentUser());
  return useQuery(queries.myConnectorGrants({ email: user?.email }), {
    enabled: enabled && userResult.type === "complete",
  });
}

export function useMyGrantForConnector(
  connectedAppId: string | undefined,
  { enabled = true } = {}
) {
  const [grants, result] = useMyConnectorGrants({ enabled });
  const grant = grants.find(
    (grant) =>
      grant.connectedAppId === connectedAppId && grant.subjectKind === "user"
  );
  return [grant, result] as const;
}
